import React from "react";
import {DataTable, Modal, P} from "@tag/tag-components-react-v4";
import {OrganisationDTO} from "../../types/OrganisationDTO";
import {useMsal, useIsAuthenticated} from "@azure/msal-react";
import AppRolesService from "../../../General/services/AppRolesService";
import { ProjectAccents } from "../../../General/config/projectAccents";

function WorkspaceDetails(props: { visible: boolean, selectedOrganisation: OrganisationDTO, handleClose: Function }) {
    const {accounts} = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const isAdmin = AppRolesService.isUserAdmin(accounts, isAuthenticated);

    const columns = React.useMemo(
        () => [
            { accessorKey: 'displayName', header: 'Property'},
            { accessorKey: 'value', header: 'Value'}
        ],
        [],
    );

    const data = [
        {
            key: 'organisationId',
            displayName: 'Organisation ID',
            value: props.selectedOrganisation.id
        },
        {
            key: 'private',
            displayName: 'Private Key',
            value: isAdmin ? props.selectedOrganisation.apiPrivateKey : "Please check the Evo admin tool"
        },
        {
            key: 'public',
            displayName: 'Public Key',
            value: props.selectedOrganisation.apiPublicKey
        }
    ]

    const renderModalContent = () => {
        return (
            <>
                <DataTable
                    columns={columns}
                    data={data}
                    noDataElement={<P>Sorry, there is no Workspace Data available.</P>}
                />
            </>
        )
    }

    let content;
    content = <>
        <Modal
            visible={props.visible}
            accent={ProjectAccents.PoliciesAndProcedures}
            heading={`Workspace Details`}
            primaryButtonProps={{buttonStyle: {'display': 'none'}}}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onClose={() => props.handleClose()}
        >
            <div style={{marginTop: '16px'}}>
                {renderModalContent()}
            </div>
        </Modal>
    </>

    return (
        <>
            {content}
        </>
    )
}

export default WorkspaceDetails;
